import App from '@app/App';
import { ConditionalDebugPanel } from '@lib/dev-tools/ConditionalDebugPanel';
import type { PropsWithChildren } from 'react';

const BlankLayout = ({ children }: PropsWithChildren) => (
  <App>
    <div className="min-h-screen text-black dark:text-white-dark">{children}</div>
    {/* Enhanced Debug Tools Panel */}
    <ConditionalDebugPanel />
  </App>
);

export default BlankLayout;
